import { formatAddress } from '../utils/check-value';
import api from './client';

export const userService = {
    addUser: async (credentials) => {
        const response = await api.post('users', credentials);
        return response.data;
    },
    getAllUsers: async () => {
        var response = await api.get('users');
        if (Array.isArray(response?.data?.data)) {
            response = response?.data?.data?.map((user) => ({
                ...user,
                address: formatAddress(user),
                username: user?.first_name + " " + user?.last_name,
            }))
            return response;
        }
        return [];
    },
    updateUser: async (id, credentials) => {
        const response = await api.put(`users/${id}`, credentials);
        return response.data;
    },
    deleteUser: async (id) => {
        const response = await api.delete(`users/${id}`);
        return response.data;
    },
    changePassword: async (id, credentials) => {
        const response = await api.put(`users/${id}/change-password`, credentials);
        return response.data;
    },

    // Position
    addPosition: async (id, credentials) => {
        const response = await api.put(`users/${id}`, credentials);
        return response.data;
    },
    // Insert Training
    addInsertTraining: async (id, credentials) => {
        const response = await api.post(`users/${id}/trainings`, credentials);
        return response.data;
    },
    getAllInsertTrainings: async (id) => {
        const response = await api.get(`users/${id}/trainings`);
        return response.data;
    },
    updateInsertTraining: async (id, credentials) => {
        const response = await api.put(`trainings/${id}`, credentials);
        return response.data;
    },
    deleteInsertTraining: async (id) => {
        const response = await api.delete(`trainings/${id}`);
        return response.data;
    },


    addLessDetailsUser: async (credentials) => {
        const response = await api.post('register', credentials);
        return response.data;
    },
};